module.exports = __webpack_public_path__ + "img-acb0abb321cf6189da66408b61801dd6.png";


//////////////////
// WEBPACK FOOTER
// ./example/app/common/commonmenu/images/cloud-logo.png
// module id = 8
// module chunks = 40